import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface BarHorizontalProps {
    data: {
        year: string;
        "0-05L": number;
        "05-10L": number;
        "10-20L": number;
        "20-40L": number;
        "40L & above": number;
    }[];
}

const EmployeesBySalaryRange: React.FC<BarHorizontalProps> = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart layout="horizontal" data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="0-05L" stackId="a" fill="#FF9AA2" />
                <Bar dataKey="05-10L" stackId="a" fill="#FFB347" />
                <Bar dataKey="10-20L" stackId="a" fill="#A2C4FC" />
                <Bar dataKey="20-40L" stackId="a" fill="#FF9472" />
                <Bar dataKey="40L & above" stackId="a" fill="#FF6F61" />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default EmployeesBySalaryRange;
